import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { MTReturnModel, } from '../models/models'

export class GetMTListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/orderReport/GetOrderedMTList',
      requesterInfo,
    })
  }

  public async getMTList(): Promise<MTReturnModel[]> {
    return await this.getAsync<MTReturnModel[]>()
  }
}
